import { useGetActiveVariant } from 'pages/documents_v2/views/edit_area/hooks/useGetActiveVariant';

export function useIsPreviewMode() {
    const activeVariant = useGetActiveVariant();

    return activeVariant && activeVariant.parentId !== null;
}
